import isEmpty from 'lodash/isEmpty';
import Catalyst from '@Services/Catalyst';

// eslint-disable-next-line import/prefer-default-export
export const trackRegistrationErrors = (errors, isFeError) => {
  if (isEmpty(errors)) {
    return;
  }

  errors.forEach((e) => {
    Catalyst.trackEvent('formError', {
      form: {
        errorType: `${isFeError ? 'fe' : 'be'} - ${e}`,
      },
    });
  });
};
